import React, { useContext } from 'react';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import {
  CustomFieldMutations,
  DeleteCustomFieldResponse,
  DeleteCustomFieldVariables,
} from '../../../../graphql/customField.graphql';
import useMutation from '../../../../hooks/useMutation';
import { useToast } from '../../../../providers/ToastProvider';
import { CustomField, CustomFieldInput } from '../../../../types/custom_field';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant, CancelButton } from '../../../components/Button';
import { AlertModal } from '../../../components/Modal';
import { ToastType } from '../../../components/Toast';

interface DeleteCustomFieldModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  customField: CustomField;
}

export default function DeleteCustomFieldModal({ open, setOpen, customField }: DeleteCustomFieldModalProps) {
  const { showToast } = useToast();

  const { customFields, setCustomFields } = useContext(CustomFieldContext);

  const [remove, { loading }] = useMutation<DeleteCustomFieldResponse, DeleteCustomFieldVariables>(
    CustomFieldMutations.remove,
    {
      variables: { customFields: [new CustomFieldInput(customField).forDelete()] },
      onCompleted: response => {
        customFields.delete(response.deleteCustomField[0].id);
        setCustomFields(new Map(customFields));
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.customFieldDeleteSuccessfullyToastTitle).singular.upper,
        });
        setOpen(false);
      },
    },
  );

  return (
    <AlertModal title={t(TranslationKey.deleteCustomFieldModalTitle).singular.upper} open={open} setOpen={setOpen}>
      <div className='grid gap-4'>
        <p className='subtitle'>{t(TranslationKey.deleteCustomFieldModalSubtitle).singular.upper}</p>

        <div className='flex justify-end gap-2'>
          <CancelButton onClick={() => setOpen(false)} disabled={loading} />
          <Button
            variant={ButtonVariant.danger}
            text={t(TranslationKey.deleteCustomField).singular.upper}
            onClick={() => remove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
